export default {
  'Add Cut': 'Agregar fragmento',
}